import BaseListPage from "../../../base/BaseListPage";
import DateRange from "../../../components/DateRange";
import PageContainer from "../../../components/PageContainer/PageContainer";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { formatDateTime } from "../../../utils/dateFormat";
import withRouter from "../../../utils/withRouter";
import Card from "./components/Card";
import SearchLogsListPresenter from "./SearchLogsPresenter";

class SearchLogsListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new SearchLogsListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      upsertUseCase(),
      deleteObjectUseCase()
    );

    this.state = {
      objects: [],
      credit: {},
      selected: [],
      loading: false,
      total: 0,
      count: 0,
    };

    this.fieldsToDisplay = [
      "searcher",
      "searched_first_name",
      "searched_middle_name",
      "searched_last_name",
      "searched_alias",
      "createdAt",
    ];
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "search_logs";
  }

  setCredit(credit) {
    this.setState({ credit });
  }

  formatFields(fields) {
    const {
      searched_first_name,
      searched_last_name,
      searched_middle_name,
      searched_alias,
      ...rest
    } = fields;

    return {
      ...rest,
      createdAt: {
        ...rest.createdAt,
        type: "String",
        label: "Date Searched",
      },
      searcher: {
        ...rest.searcher,
        type: "String",
        label: "Search By",
      },
      searchedName: {
        type: "String",
        label: "Searched Name",
      },
    };
  }

  formatObjects(objects) {
    return objects.map((object) => {
      return {
        ...object,
        searcher: `${object.searcher.firstName} ${
          object.searcher.middleName || ""
        } ${object.searcher.lastName}`.trim(),
        createdAt: formatDateTime(object.createdAt),
        searchedName: object.searched_company
          ? object.searched_company
          : `${object.searched_first_name} ${
              object.searched_middle_name || ""
            } ${object.searched_last_name} ${object.searched_alias}`.trim(),
      };
    });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count } = this.state;

    return (
      <PageContainer
        title="Search Logs"
        infiniteScroll={{
          loadMore: this.loadMore.bind(this),
          hasMore: !loading && count > objects.length,
        }}
      >
        <div className="d-flex justify-content-between mb-2 mt-2">
          <div style={{ width: "fit-content" }}>
            <DateRange
              field="createdAt"
              onChange={this.onChangeDate.bind(this)}
            />
          </div>
          <div className="d-flex gap-3 align-items-center">
            <Card
              title="Total Search"
              value={count}
              date={objects[0]?.createdAt}
              icon="bi bi-c-circle"
            />
          </div>
        </div>
        <Table
          fields={this.formatFields(schema.fields)}
          objects={this.formatObjects(objects)}
          progress={loading}
          excludeFields={Object.keys(schema.fields).filter(
            (key) => !this.fieldsToDisplay.includes(key)
          )}
        />
      </PageContainer>
    );
  }
}

export default withRouter(SearchLogsListPage);
